module.exports = __webpack_public_path__ + "static/media/dark.0a326fb4.jpg";